export const notUndefined = <T>(x: T | undefined): x is T => x !== undefined
